import library from '@/assets/img/users-cases/library.webp';
import libraryHow from '@/assets/img/users-cases/library-how.webp';
import libraryResult from '@/assets/img/users-cases/library-result.webp';

export default {
  slug: 'library',
  order: 11,
  title: '3D Interior Library Space',
  subtitle: 'Quiet space layouts shown in detailed 2D and 3D',
  tags: ['librarylayouts', 'libraryinteriordesign'],

  images: {
    hero: library,
    aboutTop: libraryHow,
    aboutBottom: libraryResult,
  },

  howText:
    'We created library floor plan, 2D and 3D layouts for libraries, and interior design for library including furniture, lighting, and aisle planning.',

  resultText:
    'Clients receive ready plans for marketing, presentations, and quick project approvals, ensuring functional and visitor-friendly libraries.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
